import queryString from 'query-string'

const router = {
    push: (router: any) => {
        const { pathname, query, target } = router
        const params = queryString.stringify(query)
        // console.log(['Navigate to', pathname, query, params])
        window.open(`${pathname}${params ? `?${params}` : ''}`, target || '_self')
    },
}

export const route = {
    app: {
        initial: () => `/`,
        accounts: {
            initial: () => `/cuentas-tarjetas/cuentas`,
            junior: () => `/cuentas-tarjetas/cuentas/cuentas-menores`,
        },
        cards: () => `/cuentas-tarjetas/tarjetas`,
        investment: {
            funds: {
                initial: () => `/inversion/fondos-inversion`,
                indexPortfolio: () => `/inversion/fondos-inversion/carteras-indexadas`,
                indexFunds: () => `/inversion/fondos-inversion/fondos-indexados`,
                plusFunds: () => `/inversion/fondos-inversion/fondos-plus`,
                fundFinder: () => `/inversion/fondos-inversion/buscador`,
            },
            pensionPlans: () => `/inversion/planes-pensiones`,
        },
        mortgage: {
            initial: () => `/hipotecas`,
            fixed: () => `/hipotecas/hipoteca-fija`,
            variable: () => `/hipotecas/hipoteca-variable`,
        },
        knowUs: () => `/conocenos`,
        contact: () => `/contacto`,
        help: {
            frequentQuestions: () => `/ayuda/preguntas-frecuentes`,
        },
        legal: {
            legal: () => `/legal/aviso-legal`,
            info: () => `/legal/informacion-legal`,
            cookies: () => `/legal/politica-cookies`,
        },
        blog: () => `/`,
        press: () => `/notas-de-prensa`,
        julia: () => `/julia`,
        simulator: {
            mortgages: () => `/simuladores/hipotecas`,
        },
    },
    external: {
        newAccount: () =>
            `https://newapp.myinvestor.es/auth/signup/intro/?data_trigger=Footer_cta_Apertura&data_traffic_origin=Web_Blog`,
    },
    errors: {
        notFound: () => '/not-found',
    },
};

export default router